export default __webpack_public_path__ + "media/images/promare/promare3-a9240942609b0d1c7390e4ea42e8d611.jpg";